import { createAction } from '@reduxjs/toolkit'

export const flushAllAction = createAction('global/flushAll')
